/* Copyright (c) 2020-2025 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Children, cloneElement } from "react";
import { FieldError } from "react-hook-form";
import { When } from "react-if";
import styled, { CSSObject } from "styled-components";
import { theme, Text } from "@nordcloud/gnui";
import { isNotNil } from "~/tools";

type Props = {
  children: JSX.Element | JSX.Element[];
  error?: Omit<FieldError, "type">;
  customCss?: CSSObject;
  customErrorCss?: CSSObject;
};

export function FormGroup({
  children,
  error,
  customCss = {},
  customErrorCss = {},
}: Props) {
  const hasError = isNotNil(error);

  return (
    <div
      css={[
        {
          width: "100%",
          marginBottom: theme.spacing.spacing05,
          position: "relative",
        },
        customCss,
      ]}
    >
      {Children.map(children, (element) => {
        return cloneElement(element, {
          ...element.props,
          ...(hasError && { status: "danger" }),
        });
      })}
      <When condition={hasError}>
        <TextWrap css={customErrorCss}>
          <Text size="sm" color="danger" tag="div">
            {error?.message}
          </Text>
        </TextWrap>
      </When>
    </div>
  );
}

const TextWrap = styled.div`
  position: absolute;
  bottom: 0;
  transform: translateY(100%);
`;
